import { Select, Tooltip } from "antd";
import { Option } from "antd/es/mentions";
import { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../../assets/style/featuresStyle/select.scss";

const SelectValue = ({
  width = 130,
  optionsValue,
  handleChange,
  defaultValue,
  type,
  value,
  key = "selecter",
  icon,
  style,
  styleItem,
  handleClickIcon,
  textJustify,
  placeholder,
}) => {
  const { t } = useTranslation();
  const [defaultSelect, setDefaultSelect] = useState(defaultValue);
  useEffect(() => {
    if (!defaultValue) return;
    setDefaultSelect(defaultValue);
  }, [defaultValue]);
  return (
    <>
      <Select
        key={key}
        value={value}
        style={{ width, height: "34px", ...style }}
        onChange={handleChange}
        defaultValue={t(defaultSelect)}
        placeholder={placeholder}
        className={type}
      >
        {optionsValue.map((value) => {
          return (
            <Option
              key={value.value}
              value={value.value}
              style={{ ...styleItem, display: "block", position: "relative" }}
            >
              <span
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: icon ? "space-between" : textJustify,
                  paddingRight: icon ? "3rem" : null,
                  maxWidth: "98%",
                  overflow: "hidden",
                }}
                className="labelSelect"
              >
                {value.label}{" "}
                <span
                  className="iconX"
                  style={{
                    display: "block",
                    position: "relative",
                    zIndex: "9999",
                    cursor: "pointer",
                  }}
                  onClick={(e) => handleClickIcon(e, value)}
                >
                  {icon}
                </span>
              </span>
            </Option>
          );
        })}
      </Select>
    </>
  );
};

export default SelectValue;
